import * as EventUtils from '../../utils/event-utils';
import { keycodesModule } from '../../constants/keycodes';
import {
  GLOBAL_ACTION_KEYS,
  globalActionsComponentModule,
} from '../global-actions/global-actions';

export const globalEventsComponentModule = angular
  .module('Q.components.global-events', [
    keycodesModule,
    globalActionsComponentModule,
  ])

  /**
   * @name GlobalEvents
   * @docType shared
   * @category directive
   * @param $document {service} - Angular {@link https://docs.angularjs.org/api/ng/service/$document $document} service
   * @param $rootScope {service} - Angular {@link https://docs.angularjs.org/api/ng/service/$rootScope $rootScope} service
   * @description
   * The globalEvents directive allows you to listen in to global keyboard (and other)
   * events via scope events.
   *
   * Events are broadcast down the scope in the form of «event-type», and for keyboard events,
   * «event-type»:«keycode» and «event-type»:«common-name»
   *
   */
  .directive(
    'globalEvents',
    function ($document, $rootScope, KeyCodes, globalActionsService) {
      const bound = {};
      const commonCodes = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        27: 'escape',
        32: 'space',
        33: 'pagedown',
        34: 'pageup',
        35: 'home',
        36: 'end',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        46: 'delete',
      };
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          const eventType = attrs.globalEvents || 'keydown';

          // we only want a single global-events emitter per type
          if (!bound[eventType]) {
            bound[eventType] = function (e) {
              if (e.defaultPrevented) return;
              const which = e.keyCode || e.which;
              const common = commonCodes[which];
              const char = e.key && e.key.length === 1 && e.key.toLowerCase();
              const props = { which, common, char };
              let prevented = $rootScope.$broadcast(
                eventType,
                e,
                props,
              ).defaultPrevented;
              if (!prevented && /key/.test(eventType)) {
                prevented = $rootScope.$broadcast(
                  eventType + ':' + which,
                  e,
                  props,
                ).defaultPrevented;
                if (!prevented) {
                  if (common) {
                    prevented = $rootScope.$broadcast(
                      eventType + ':' + common,
                      e,
                      props,
                    ).defaultPrevented;
                  } else if (char) {
                    prevented = $rootScope.$broadcast(
                      eventType + ':' + char,
                      e,
                      props,
                    ).defaultPrevented;
                  }
                }
              }

              if (!prevented && (common || char)) {
                let actionKey = '';
                if (KeyCodes.isCommand(e)) {
                  actionKey += 'Command-';
                }
                if (KeyCodes.isAlt(e)) {
                  actionKey += 'Alt-';
                }
                if (KeyCodes.isShift(e)) {
                  actionKey += 'Shift-';
                }
                actionKey += common || char;
                const action = GLOBAL_ACTION_KEYS[actionKey];
                if (action) {
                  prevented = globalActionsService[action](e, props);
                }
              }

              if (prevented) {
                EventUtils.stopEvent(e);
              }
            };
            $document.on(eventType, bound[eventType]);
            // track how many listeners we have on this event
            bound[eventType].count = 1;
          } else {
            bound[eventType].count++;
          }

          scope.$on('$destroy', function () {
            bound[eventType].count--;
            if (bound[eventType].count < 1) {
              $document.off(eventType, bound[eventType]);
              bound[eventType] = false;
            }
          });
        },
      };
    },
  );
